var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"help-lgpd"}},[_c('VuePerfectScrollbar',{staticClass:"attendance-scroll-area",attrs:{"settings":_vm.settings}},[_c('div',{staticClass:"content-lgpd"},[_c('h1',[_vm._v(_vm._s(_vm.$t("HELP_LGPD").LGPD_Title))]),_c('div',[_c('span',{staticClass:"texto-cma"},[_vm._v(_vm._s(_vm.$t("HELP_LGPD").LGPD_Text))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }